import { TYPING_UNITS } from '../../../flowConstants';

export default function TypingNode({ id, data }) {
    const typingAction = data?.typingAction || 'typing';
    const typingValue = data?.typingValue ?? '';
    const typingUnit = data?.typingUnit || 'seconds';

    return (
        <div className="mt-2 space-y-2">
            <select className="form-select w-full" value={typingAction}
                onChange={(e) => data?.onChangeTyping?.(id, { typingAction: e.target.value })}>
                <option value="typing">Digitando...</option>
                <option value="record_voice">Gravando audio...</option>
            </select>
            <div className="grid grid-cols-2 gap-2">
                <input type="number" min="1" step="1" className="input3" placeholder="Tempo"
                    value={typingValue}
                    onChange={(e) => data?.onChangeTyping?.(id, { typingValue: e.target.value })} />
                <select className="form-select w-full" value={typingUnit}
                    onChange={(e) => data?.onChangeTyping?.(id, { typingUnit: e.target.value })}>
                    {TYPING_UNITS.map((unit) => (
                        <option key={unit.value} value={unit.value}>{unit.label}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
